// extracted by mini-css-extract-plugin
export default {"paymentSection":"u9-z","disabled":"v9-z"};